import React, { useState } from 'react'
import { Radio } from '../common'
import { Collapse, Media } from 'reactstrap';

const RearrengeItem  = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const { data, hanndleResponse, questions, name } = props;
  const question =  questions.find( (question) => question.id === data.item_id )

  if (!question) return null;

  const handleDragStart = (e) => {
    setIsDragging(true);
    e.dataTransfer.setData('id', `${question.id}`);
    e.dataTransfer.setData('value', `${data.value}`);
  }

  const handleDragEnd = (e) => {
    setIsDragging(false);
  }

  return (
    <div 
      className={`item rearrenge-item clearfix border-bottom py-3`}
      draggable
      onDragStart={handleDragStart} 
      onDragEnd={handleDragEnd}
    >
      <div id={`toggler${question.id}`} onClick={toggle} className="cursor-pointer">
        <Media className='align-items-center'>
          <div className='mr-2 d-none d-lg-inline-block'>
            <i>
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#ADABAB" height="13" width="8" viewBox="0 0 7.5 12.5">
                <path d="M0.9,1.9c0.5,0,0.9-0.4,0.9-0.9S1.5,0,0.9,0S0,0.4,0,0.9S0.4,1.9,0.9,1.9z"/>
                <path d="M6.6,1.9c0.5,0,0.9-0.4,0.9-0.9S7.1,0,6.6,0S5.6,0.4,5.6,0.9S6,1.9,6.6,1.9z"/>
                <path d="M0.9,7.2c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9S0,5.7,0,6.2C0,6.8,0.4,7.2,0.9,7.2z"/>
                <path d="M6.6,7.2c0.5,0,0.9-0.4,0.9-0.9c0-0.5-0.4-0.9-0.9-0.9S5.6,5.7,5.6,6.2C5.6,6.8,6,7.2,6.6,7.2z"/>
                <path d="M0.9,12.5c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9S0,11,0,11.6S0.4,12.5,0.9,12.5z"/>
                <path d="M6.6,12.5c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9S5.6,11,5.6,11.6S6,12.5,6.6,12.5z"/>
              </svg>
            </i>
          </div>
          <Media left className={`mr-3 icon ml-md-n0 rounded-circle border border-${name} bg-${name === 'sometimes' ? 'transparent' : name}`}>
            <img className={`media-object `} width="30" height="30" src={question.icon_invert} alt={ question.name }/>
          </Media>
          <Media body>
            <Media heading tag="p" className="mb-0 line-height-normal font-weight-semibold">
              { question.name }<br/><small>{question.question}</small>
            </Media>
          </Media>
          <div className='ml-2 d-lg-none pr-2'>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#ADABAB" className="bi bi-chevron-down" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
              </svg>
            </i>
          </div>
        </Media>
      </div>
      <div className='d-block d-lg-none'>
        <Collapse isOpen={isOpen}>
          <Media>
            <Media left className="mr-3 icon"><div style={{ width: "48px"}}></div></Media>
            <Media body>
              <div className="btn-group btn-group-toggle pt-3">
                { data.value === '2' && <Radio handleRadioChange={hanndleResponse} item_id={data.item_id} group="gives_me_energy_" label="ALWAYS" value="1" /> }
                { data.value !== '2' && <Radio handleRadioChange={hanndleResponse} item_id={data.item_id} group="gives_me_energy_" label="SOMETIMES" value="2" /> }
                { data.value === '2' && <Radio handleRadioChange={hanndleResponse} item_id={data.item_id} group="gives_me_energy_" label="NEVER" value="3" /> }
              </div>
            </Media>
          </Media>
        </Collapse>
      </div>
    </div>
  )
}

export default RearrengeItem
